import React from 'react';
import Style from './formPreview.module.css';
import { InputLabel, InputSublabel } from '@weezevent/nacre';
import Phone from '../../../components/phone/phone';

export default function FormPhone({ field = null, onChangeForm = () => {}, id = null, label = null, className = null, ...rest }) {
    const onChange = React.useCallback(
        value => {
            if (id) {
                onChangeForm(id, value);
            }
        },
        [id, onChangeForm]
    );

    return (
        <div className={`${Style['field']} ${className}`}>
            <InputLabel label={label} required={field.required} />
            {field.form_field.description && <InputSublabel label={field.form_field.description} />}
            <Phone field={field} onChange={onChange} {...rest} />
        </div>
    );
}
